module.exports = __webpack_public_path__ + "static/media/pulmonologyImage1.ba85080c.png";